import { render, staticRenderFns } from "./NomHrOrg.vue?vue&type=template&id=357c17ac&scoped=true&"
import script from "./NomHrOrg.ts?vue&type=script&lang=ts&"
export * from "./NomHrOrg.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c17ac",
  null
  
)

export default component.exports
import {QTree} from 'quasar'
component.options.components = Object.assign({QTree}, component.options.components || {})
